export default __webpack_public_path__ + "static/media/role.b745b4e1.wav";